import React, { useEffect, useState } from "react";
//Css Here
import { getRaffle } from "@network/Raffle";
import { Raffle } from "@type/Raffle";
//Css Here
import { SCREEN } from "@type/index";
import RaffleSwiperRender from "../Dashboard/Components/RaffleSwipeRender";
// import * as S from "./style";
// import useDataSideBar from "src/hooks/useDataSideBar";
// import headerIcon from "../../../assets/img/headerIcon.svg";
import HeroRaffle from "@components/DashboardBox/HeroRaffle";

interface RaffleData {
  raffles: {
    nextRaffle: Raffle;
    daily: {
      raffles: Raffle[];
      total: number;
    };
    weekly: {
      raffles: Raffle[];
      total: number;
    };
    monthly: {
      raffles: Raffle[];
      total: number;
    };
    quarterly: {
      raffles: Raffle[];
      total: number;
    };
    halfYear: {
      raffles: Raffle[];
      total: number;
    };
    annually: {
      raffles: Raffle[];
      total: number;
    };
    special: {
      raffles: Raffle[];
      total: number;
    };
  };
}

const FavoriteRaffle: React.FC = () => {
  const [raffleData, setRaffleData] = useState<RaffleData>();
  // const [navbar, setNavbar] = useState(false);
  const limit = 5;
  // const { DataSideDashboardBar } = useDataSideBar();

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    const data = {
      limit: limit,
      offset: 0,
      type: "ALL",
      screen: SCREEN.FAVORITE,
    };
    try {
      const response = await getRaffle(data);
      // Response structure: { data: { raffles: {...} } }
      // Set raffleData to response.data which contains { raffles: {...} }
      setRaffleData(response.data);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  // const changeBackGround = () => {
  //   if (window.scrollY > 20) {
  //     setNavbar(true);
  //   } else setNavbar(false);
  // };
  // window.addEventListener("scroll", changeBackGround);

  return (
    <>
      <HeroRaffle title="My Favorite Raffle" subtitle="Check all your favorites raffles from here" />
      <RaffleSwiperRender
        raffleData={raffleData}
        skipFirstItem={false}
        screen={SCREEN.FAVORITE}
      />
      {/* <S.Wrapper>
        <Sidebar sideData={DataSideDashboardBar} />
        <S.ContainerNavigate className={navbar ? "activeBg" : ""}>
          <Navigate />
          <BreadcrumbNav />
        </S.ContainerNavigate>
        <S.ContainerWrapper>
          <HeaderBar backToDashboard={true} title="Back to Dashboard" />
          <S.RaffleContainer>
            <p className="title">My Favorite Raffle</p>
            <RaffleSwiperRender raffleData={raffleData} />
          </S.RaffleContainer>
        </S.ContainerWrapper>
        <ReferFriend />
      </S.Wrapper> */}
      {/* 
      <div style={{}} className="dabour-dashboard-header">
        <div className="mobile-hidden">
          <HeaderBar />
        </div>
        <div>
          <S.ContainerNavigate className={navbar ? "activeBg" : ""}>
            <Navigate />
          </S.ContainerNavigate>
        </div>
        <div className="main-body-raffle-detail">
          <Sidebar sideData={DataSideDashboardBar} />
          <div className="main-body-dashboard-right">
            <div className="mt-0 md:!mt-16">
              <S.RaffleContainer>
                <div className="p-10 bg-[#EAF0D5]">
                  <div className="flex flex-col items-start gap-2">
                    <div className="flex relative w-fit">
                      <h1 className="text-[28px] !text-[#343535]">My Favorite Raffle</h1>
                      <span className="absolute -top-6 -right-6">
                        <img src={headerIcon} alt="icon" />
                      </span>
                    </div>
                    <p className="!text-[18px] !text-[#343535] mb-0">
                      Check all your favorites raffles from here
                    </p>
                  </div>
                </div>
                <div className="p-0 md:!p-4"></div>
                <RaffleSwiperRender
                  raffleData={raffleData}
                  skipFirstItem={false}
                  screen={SCREEN.FAVORITE}
                />
              </S.RaffleContainer>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default FavoriteRaffle;
